function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

document.querySelectorAll('.whatsapp').forEach((whatsappElement) => {
  whatsappElement.addEventListener('click', function (e) {
    var iframe = document.getElementById('toggle-iframe');

    if (iframe && iframe.contentWindow) {
      var iframeDocument = iframe.contentWindow.document;

      var button = iframeDocument.querySelector('button');
      if (button) {
        button.click();
      }
    }
  });
});
